<template>
  <footer-contact>
    <div class="footer-socials">
      <a
        class="footer-socials__link"
        href="https://www.instagram.com/spotanddot_creative/?hl=pl"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          style="enable-background:new 0 0 24 24;"
          xml:space="preserve"
          class="icon-svg"
        >
          <path
            class="icon-svg__background"
            d="M0 0h24v24H0z"
          />
          <g class="icon-svg__icon">
            <path
              fill-rule="nonzero"
              d="M8.706 5.117a2.598 2.598 0 0 0-2.59 2.589v7.588a2.598 2.598 0 0 0 2.59 2.59h7.588a2.598 2.598 0 0 0 2.59-2.59V7.706a2.598 2.598 0 0 0-2.59-2.59H8.706zm0-1.117h7.588A3.715 3.715 0 0 1 20 7.706v7.588A3.715 3.715 0 0 1 16.294 19H8.706A3.715 3.715 0 0 1 5 15.294V7.706A3.715 3.715 0 0 1 8.706 4zm.872 7.5a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.844 0zm-1.116 0a4.038 4.038 0 1 1 8.076 0 4.038 4.038 0 0 1-8.076 0z"
            />
            <path d="M16.081 7.378a.676.676 0 1 1 1.351 0 .676.676 0 0 1-1.35 0"/>
          </g>
        </svg>
      </a>
      <a
        class="footer-socials__link"
        href="https://www.facebook.com/spotanddotagency/?epa=SEARCH_BOX"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          style="enable-background:new 0 0 24 24;"
          xml:space="preserve"
          class="icon-svg"
        >
          <path
            class="icon-svg__background"
            d="M0 0h24v24H0z"
          />
          <path
            class="icon-svg__icon"
            d="M13.512 8.66V7.41c0-.598.455-.743.786-.743h2.004V4h-2.761c-3.07 0-3.759 1.975-3.759 3.258V8.66H8v3.115h1.801v7.781h3.575v-7.781h2.646l.116-1.225.213-1.89h-2.839"
          />
        </svg>
      </a>
    </div>
  </footer-contact>
</template>

<script>
import FooterContact from '@/components/FooterContact'
export default {
  components: {
    FooterContact
  }
}
</script>

<style lang="scss" scoped>
  .footer-socials {
    @include grid-column((xs: 12, xl: 1));
    padding: 0!important;
    display: flex;
    justify-content: flex-end;
    .icon-svg {
      height: 1.5em;
      width: 1.5em;
      margin-left: 1em;
      &__background,
      &__icon {
        transition: all 0.3s ease;
      }
      &__background {
        fill: #000;
      }
      &__icon {
        fill: #fff;
      }
      &:hover {
        .icon-svg__background {
          fill: #fff;
        }
        .icon-svg__icon {
          fill: #000;
        }
      }
    }
    @include media-down(xl) {
      justify-content: flex-start;
      .icon-svg {
        margin-left: 0;
        margin-right: 1em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Footer.vue